import { LncBaseApiClientService } from '@odw/lnc-services/js-services/api-client/lnc-base-api-client.service';

/**
 * Service pour réaliser les appels à l'api de DLT (délestage)
 */
export default class CartoDelestageService extends LncBaseApiClientService {
  /**
   * Appel au partenaire Webdelest pour récupérer le statut de la réponse
   * @param {string} siren
   * @param {string} codeInsee
   * @param {string} date
   * @param {string} cnAlex
   * @param {string} hash code TOTP généré suite à l'appel au backend MAC
   * @returns {Promise<number>} Statut de la réponse :
   *
   * 200 : délestage en cours pour la commune correspondant au codeInsee (affichage nominal de la carte)
   *
   * 400 : l'import est toujours en cours côté partenaire
   *
   * 404 : pas de délestage en cours pour la commune correspondant au codeInsee
   *
   * 401 : hash non validé côté Webdelest
   *
   * 50x : erreurs techniques côté Webdelest
   */
  getStatutCartoDelestage(siren, codeInsee, date, cnAlex, hash) {
    return new Promise((resolve) => {
      this.get(this.buildParamsGetCartoDelestage(siren, codeInsee, date, cnAlex, hash))
        .then((response) => {
          resolve(response.status);
        })
        .catch((e) => {
          resolve(e.status);
        });
    });
  }

  /**
   * Génération de l'url d'appel à l'api GET cartographie délestage
   * @param {string} siren
   * @param {string} codeInsee
   * @param {string} date
   * @param {string} cnAlex
   * @param {string} hash code TOTP généré suite à l'appel au backend MAC
   * @returns l'url d'appel à l'api GET cartographie délestage
   */
  buildApiUrlGetCartoDelestage(siren, codeInsee, date, cnAlex, hash) {
    return this.baseUrl + this.buildParamsGetCartoDelestage(siren, codeInsee, date, cnAlex, hash);
  }

  /**
   * Génération des paramètres d'url pour l'api GET cartographie délestage
   * @param {string} siren
   * @param {string} codeInsee
   * @param {string} date
   * @param {string} cnAlex
   * @param {string} hash code TOTP généré suite à l'appel au backend MAC
   * @returns
   */
  buildParamsGetCartoDelestage(siren, codeInsee, date, cnAlex, hash) {
    return `/${siren}/${codeInsee}/${date}/${cnAlex}?maphash=${hash}`;
  }
}
